<template>
  <RouterLink
    v-slot="{ isActive, href, navigate }"
    custom
    :to="{ name: 'Library' }"
  >
    <a :href="href" class="MenuItemLibrary" @click="navigate">
      <TheSidebarMenuItem :isActive="isActive">
        <template #icon>
          <UIIcon name="bookSparklesRegular" />
        </template>
        <template #label>Library</template>
      </TheSidebarMenuItem>
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { UIIcon } from '@foundever/ui-lib'

import TheSidebarMenuItem from '../TheSidebarMenuItem.vue'
</script>

<style scoped lang="scss">
.MenuItemLibrary {
  display: block;
  text-decoration: none;
}
</style>
